module.exports = __webpack_public_path__ + "static/media/robot-animated.34e85998.gif";